import { render, staticRenderFns } from "./BloodSampleReview.vue?vue&type=template&id=5176523d&scoped=true&"
import script from "./BloodSampleReview.vue?vue&type=script&lang=js&"
export * from "./BloodSampleReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5176523d",
  null
  
)

export default component.exports